export default "__VITE_ASSET__X_e9PB2l__"